import gql from 'graphql-tag'

export const QueryFeedCheckReachability = gql(`query checkReachability($auid: String!, $feed_id: ID!, $params: S3PushParametersInput) {
  feedCheckReachability(auid: $auid, feed_id: $feed_id, params: $params) {
    feed_id
    lines
    ok
  }
}`)



// WEBPACK FOOTER //
// ./src/graphql/QueryFeedCheckReachability.js